<!--<div class="modal-dialog modal-dialog-centered modal-dialog-scrollable">-->
<div class="modal-content">
  <form [formGroup]="formService.form" (ngSubmit)="onSubmit(formService.form.value)">
    <div class="modal-header">
      <h5 class="modal-title" id="stationAddLabel" i18n="@@CreateChargingStationHeader">Neues Profil</h5>
      <button type="button" id="x_close" class="btn-close" data-bs-dismiss="modal" aria-label="Close" (click)="onCancelClick()"></button>
    </div>
    <div class="modal-body">
      <div class="row mb-3">
        <label for="inputEmail3" class="col-sm-2 col-form-label">Hersteller*</label>
        <div class="col-sm-10">
          <select #manufacturers (change)="onSelected(manufacturers.value)" class="form-select">
            <option default>Hersteller auswählen...</option>
            <option *ngFor="let man of manufacturer" value="{{man.id}}">{{man.name}}</option>
          </select>
        </div>
      </div>
      <div class="row mb-3">
        <label for="model" class="col-sm-2 col-form-label">Modellname</label>
        <div class="col-sm-10">
          <input type="text" class="form-control" id="model" name="model" #model (change)="setModel(model.value)">
        </div>
      </div>
      <div class="row mb-3">
        <label for="model" class="col-sm-2 col-form-label">Abbildung</label>
        <div class="col-sm-10">
          <input type="file" class="form-control" id="pictureUri" name="pictureUri" #pictureUri (change)="onFileSelect($event)">
        </div>
      </div>
      <div class="row mb-3">
        <div class="col-sm-3 offset-sm-2">
          <div class="form-check">
            <input class="form-check-input" type="checkbox" id="isOcpp16" name="isOcpp16" #isOcpp16 value="1" (change)="checked($event)">
            <label class="form-check-label" for="isOcpp16">
              OCPP 1.6
            </label>
          </div>
        </div>
        <div class="col-sm-3">
          <div class="form-check">
            <input class="form-check-input" type="checkbox" id="isOcpp20" name="isOcpp20" #isOcpp20 value="1" (change)="checked($event)">
            <label class="form-check-label" for="isOcpp20">
              OCPP 2.0
            </label>
          </div>
        </div>
        <div class="col-sm-4">
          <div class="form-check">
            <input class="form-check-input" type="checkbox" id="isOcpp201" name="isOcpp201" #isOcpp201 value="1" (change)="checked($event)">
            <label class="form-check-label" for="isOcpp201">
              OCPP 2.0.1
            </label>
          </div>
        </div>
      </div>
      <div class="row mb-3">
        <div class="col-sm-5 offset-sm-2">
          <div class="form-check">
            <input class="form-check-input" type="checkbox" id="isErk" name="isErk" #isErk value="1" (change)="checked($event)">
            <label class="form-check-label" for="isErk">
              Eichrechtskonform
            </label>
          </div>
        </div>
      </div>
      <div class="row mb-3">
        <div class="col-sm-10 offset-sm-2">
          <div class="form-check">
            <input class="form-check-input" type="checkbox" id="isUpdatable" name="isUpdatable" #isUpdatable value="1" (change)="checked($event)">
            <label class="form-check-label" for="isUpdatable">
              Firmware-Updates über OCPP möglich?
            </label>
          </div>
        </div>
      </div>
      <div class="row mb-3">
        <div class="col-sm-5 offset-sm-2">
          <div class="form-check">
            <input class="form-check-input" type="checkbox" id="isMobile" name="isMobile" #isMobile value="1" (change)="checked($event)">
            <label class="form-check-label" for="isMobile">
              4G-Anbindung
            </label>
          </div>
        </div>
        <div class="col-sm-5">
          <div class="form-check">
            <input class="form-check-input" type="checkbox" id="isPnc" name="isPnc" #isPnc value="1" (change)="checked($event)">
            <label class="form-check-label" for="isPnc">
              Plug'n'charge
            </label>
          </div>
        </div>
      </div>
      <div class="row mb-3">
        <div class="col-sm-5 offset-sm-2">
          <div class="form-check">
            <input class="form-check-input" type="checkbox" id="isAc" name="isAc" #isAc value="1" (change)="checked($event)">
            <label class="form-check-label" for="isAc">
              AC
            </label>
          </div>
        </div>
        <div class="col-sm-5">
          <div class="form-check">
            <input class="form-check-input" type="checkbox" id="isDc" name="isDc" #isDc value="1" (change)="checked($event)">
            <label class="form-check-label" for="isDc">
              DC
            </label>
          </div>
        </div>
      </div>
      <div class="row mb-3 align-items-center">
        <label for="model" class="col-sm-2 col-form-label">Anzahl Ladepunkte*</label>
        <div class="col-sm-10">
          <input type="number" class="form-control" id="numberOfConnectors" name="numberOfConnectors" #numberOfConnectors value="1" (change)="setNumberOfConnectors(numberOfConnectors.value)" required>
        </div>
      </div>
      <div class="row mb-3">
        <label for="model" class="col-sm-2 col-form-label">Integration:</label>
        <div class="col-sm-10">
          <input type="datetime-local" class="form-control" id="integrationAt" name="integrationAt" #integrationAt (change)="setDate(integrationAt.value)">
        </div>
      </div>
    </div>
    <div class="modal-footer">

      <a class="btn btn-yellow" id="cancel" data-bs-toggle="modal" role="button" data-bs-dismiss="modal" (click)="onCancelClick()" i18n="@@CancelButton">Abbrechen</a>
      <button type="submit" id="create_manufacturer" class="btn btn-primary" i18n="@@CreateChargingStationButton">Profil anlegen</button>
    </div>
  </form>

</div>
<!--</div>-->



